import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { FacetGroup, FacetType } from '.'

type Props = {
  facetGroup: FacetGroup
  hasSelectedFacets: boolean
  selectedFacetsCount: number
}

export const FacetGroupHeader = ({ facetGroup, hasSelectedFacets, selectedFacetsCount }: Props) => {
  const { translate } = useTranslations()

  let headerLabel = facetGroup.displayName || translate(`FacetGroup_${facetGroup.nameInUrl}`)

  if (facetGroup.type !== FacetType.Range && hasSelectedFacets) {
    headerLabel = headerLabel.concat(' ', `(${selectedFacetsCount})`)
  }

  return <span>{headerLabel}</span>
}
